import React, { useState, useEffect } from 'react';
import { Comment } from './Comment.js';
import { addComment, getComents } from '../documents/DocumentHelpers.js';
import { v4 } from 'uuid';
import { CommentForm } from './CommentForm.js';
import { eventDispatcher } from '../../eventDispatcher.js';
import { notificationTypes, hubEventTypes } from '../../constants.js';

const CommentsForm = (props) => {
    const [comments, setComments] = useState(props.comments);

    useEffect(() => {
        const onNotificationAddedId = eventDispatcher.subscrubeToEvent(hubEventTypes.notificationAdded, (notification) => {
            if (notification.type === notificationTypes.newComment) {
                loadComments();
            }
        });

        return () => {
            eventDispatcher.unsubscrubeFromEvent(onNotificationAddedId);
        }

    }, []);

    const loadComments = () => {
        getComents(props.documentId)
            .then((comments) => {
                setComments(comments);
                if (props.onCommentChanged) props.onCommentChanged(comments);
            });
    }

    const handleAddComment = async (comment) => {
        await addComment(comment, props.documentId);
        loadComments();
    }

    return (<div className="form-block comments-form">
        <div className="form-content">
            <div className="comments">
                {comments.map((item) =>
                    <Comment key={v4()} documentId={props.documentId} comment={item} getComents={loadComments} canReply={true} />
                )}
            </div>
        </div>
        <CommentForm documentId={props.documentId} handleChangeComment={handleAddComment} />
    </div>);
}

export default CommentsForm;
